import CloseIcon from "@mui/icons-material/Close"
import { Box, Dialog as MuiDialog, DialogTitle } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import React, { memo } from "react"

export const Dialog = memo(
  /**
   * @param {Omit<import("@mui/material").DialogProps, 'title'> & {title?: React.ReactNode, titleSx?: import("@mui/material").SxProps, headerActions?: React.ReactNode}} props
   */
  ({
    title,
    onClose,
    children,
    titleSx = {},
    center,
    headerActions,
    fullScreen,
    ...rest
  }) => {
    return (
      <MuiDialog onClose={onClose} fullScreen={fullScreen} {...rest}>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            ...titleSx
          }}
        >
          {fullScreen && headerActions}
          {title ?? <div />}
          {center}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {!fullScreen && headerActions}
            <IconButton
              aria-label="close"
              onClick={(e) => onClose(e, "backdropClick")}
              sx={{ color: (theme) => theme.palette.grey[500] }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        {children}
      </MuiDialog>
    )
  }
)
